export default __webpack_public_path__ + "static/media/laudo1.f873e93c.jpg";